export default "__VITE_ASSET__ZUC4k52s__"